/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useState, useEffect, useRef } from 'react';
import { useQuery, gql } from '@apollo/client';

export const useOrderHistory = (): any => {
  const [currentPage, setCurrentPage] = useState(0);
  const [cursor, setCursor] = useState({
    before: null,
    after: null
  });
  const [historyData,setHistoryData] = useState()
  // const [pageCursors, setPageCursors] = useState<{ [key: number]: { before: string | null, after: string | null } }>({});
  const fetchTriggeredRef = useRef(false);
  const variables = {
    before: cursor.before,
    after: cursor.after,
    first: currentPage >= 0 ? 5 : null,
    last: currentPage < 0 ? 5 : null,
    pageNumber: currentPage
  };

  const ORDERHISTORY_GQL = gql`
    query Me($before: String, $after: String, $first: Int, $last: Int, $pageNumber: Int) {
      me {
        id
        orders(before: $before, after: $after, first: $first, last: $last, pageNumber: $pageNumber) {
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
            totalResultsCount
            hasPreviousPage
            startCursor
          }
          edges {
            cursor
            node {
              id
              orderExtendAttribute {
                name
                value
              }
              grandTotal {
                currency
                value
              }
              lineItems {
                id
                item {
                  fullImage
                  id
                  longDescription
                  name
                  status
                  thumbnail
                }
                linePrice {
                  currency
                  value
                }
                partnumber
                quantity
                status
                unitPrice {
                  currency
                  value
                }
              }
              placedDate
              shipping {
                currency
                value
              }
              status
              statusCode
              subTotal {
                currency
                value
              }
              taxes {
                currency
                value
              }
              totalAdjustment {
                currency
                value
              }
              updateDate
            }
          }
        }
      }
    }
  `;

  const { called, loading, data, error, fetchMore } = useQuery(ORDERHISTORY_GQL, {
    variables,
    fetchPolicy: "network-only",
     context:{
          clientName:"/account/order-history"
        }
  });

  // useEffect(() => {
  //   if (!data || fetchTriggeredRef.current) return;
  //   if (data && currentPage === 0 && cursor.before === null && cursor.after === null) {
  //     setCursor({
  //       before: null,
  //       after: null
  //     });
  //   }
  // }, [data, currentPage, cursor.before, cursor.after]);

  useEffect(() => {
    if (!data || fetchTriggeredRef.current) return;
    // Only update cursor if it's not already set
    if(cursor.before !== null && cursor.after !== null) {
      setCursor({ before: null, after: null })
    }
  }, [data]);
  useEffect(() => {
    if(data){
      setHistoryData(data)
    }
  },[currentPage,loading])
  const onLoadMore = (pageNumber) => {
     console.log("PageNumber",pageNumber)
    // console.log("pageNumber:", pageNumber);
    // if (!data || !data.me || !data.me.orders) return;
   
    if (pageNumber === currentPage || !data || !data.me || !data.me.orders || fetchTriggeredRef.current) return;
    fetchTriggeredRef.current = true;

    // const savedCursor = pageCursors[pageNumber] || { before: null, after: null };

    const isNext = pageNumber > currentPage;
    const isPrev = pageNumber < currentPage;
    const totalResultsCount = data.me.orders.pageInfo.totalResultsCount;

    let newCursor = {
      before: null,
      after: null
    };

    if (isNext && data.me.orders.pageInfo.hasNextPage) {
      newCursor.after = data.me.orders.pageInfo.endCursor;
    } else if (isPrev && data.me.orders.pageInfo.hasPreviousPage) {
      newCursor.before = data.me.orders.pageInfo.startCursor;
    }

    const totalPages = Math.ceil(totalResultsCount / 5);
    const isLastPage = (pageNumber + 1) === totalPages;

    // Calculate remaining items for the last page
    const remainingItems = totalResultsCount - (pageNumber) * 5;
    // const itemsToFetch = Math.min(5, remainingItems);
    const itemsToFetch = isLastPage ? remainingItems : 5; // Fetch only the remaining items on the last page
    console.log("INDEX", newCursor.after, newCursor.before, pageNumber)
    return fetchMore({
      variables: {
        before: newCursor.before,
        after: newCursor.after,
        first: 5,
        last: null,
        pageNumber: pageNumber
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        fetchTriggeredRef.current = false; // Reset flag after fetch completes
        if (!fetchMoreResult) return previousResult;

        const newEdges = fetchMoreResult.me.orders.edges;
        const { pageInfo } = fetchMoreResult.me.orders;

        // setPageCursors(prev => ({
        //   ...prev,
        //   [pageNumber]: { before: newCursor.before, after: newCursor.after }
        // }));
        
        return newEdges.length
          ? {
            me: {
              id: previousResult.me.id,
              orders: {
                // edges: newEdges,
                edges: isLastPage ? newEdges.slice(0, remainingItems) : newEdges, // Ensure correct count on last page

                pageInfo
              }
            }
          }
          : previousResult;
      }
    }).then(() => {
      setCurrentPage(pageNumber);
      setCursor(newCursor);
    });
  };
  console.log("History",historyData)
  return { called, loading, fetchMore,data:historyData, error, onLoadMore, currentPage };
};